import React, { useEffect, useState } from "react";
import './styles/diary.css';
import Navbar from "../navigation/Navbar";
import { Helmet } from "react-helmet";
import logo from '../../media/branding/logo.png';
import { mainGet, mainPost } from "../../domain/net/mainApi";
/* eslint-disable react-hooks/exhaustive-deps */

export default function Diary() {
    const [user, setUser] = useState({});
    const [calendar, setCalendar] = useState([]);
    const [analytics, setAnalytics] = useState(null);
    const [stClasses, setStClasses] = useState(null);
    const [loading, setLoading] = useState(true);
    const [req, setReq] = useState(false);
    const [upcomingBirthdays, setUpcomingBirthdays] = useState([]);

    const date = new Date();
    const thisMonth = (date.getMonth() + 1).toString().padStart(2, '0');
    const todayDate = date.toISOString().split('T')[0];

    // Helper functions
    const addTimes = (timeArray) => {
        let mins = timeArray.reduce((acc, time) => {
            let [h, m] = time.split('.');
            acc += h * 60 + m * 1;
            return acc;
        }, 0);
        return (mins / 60 | 0) + '.' + ('0' + (mins % 60)).slice(-2);
    };

    const getDayOfWeek = (date) => {
        const dayOfWeek = new Date(date).getDay();
        return isNaN(dayOfWeek) ? null :
            ['Воскресенье', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота'][dayOfWeek];
    };

    const clearAddTimes = (time) => {
        return time.split('.')[0] < 10 ? '0' + time.split('.')[0] + '.' + time.split('.')[1] : time;
    };

    const formatDate = (dateStr) => {
        const [year, month, day] = dateStr.split('-');
        return `${day}.${month}.${year}`;
    };

    const fetchStudents = async () => {
        const clid = localStorage.getItem('clid');
        if (!clid) return;

        try {
            const response = await mainGet({ type: 'getglobalstudents', id: clid });

            let allStudents = [];
            if (response.data && Array.isArray(response.data)) {
                allStudents = response.data;
            } else if (response.data && typeof response.data === 'object') {
                allStudents = Object.values(response.data);
            }

            // Фильтруем ближайшие дни рождения (на 7 дней вперед)
            const today = new Date();
            const nextWeek = new Date(today);
            nextWeek.setDate(today.getDate() + 7);

            const upcoming = allStudents.filter(student => {
                if (!student.bday) return false;

                const [day, month, year] = student.bday.split('.');
                const birthDate = new Date(year, month - 1, day);
                const bdayThisYear = new Date(today.getFullYear(), month - 1, day, 23, 59, 59);

                // Проверяем что день рождения в ближайшие 7 дней
                const isUpcoming = bdayThisYear >= today && bdayThisYear <= nextWeek;

                if (isUpcoming) {
                    // Добавляем вычисление возраста
                    student.age = today.getFullYear() - birthDate.getFullYear();
                    // Корректируем если день рождения еще не наступил в этом году
                    if (today.getMonth() < birthDate.getMonth() ||
                        (today.getMonth() === birthDate.getMonth() && today.getDate() <= birthDate.getDate())) {
                        student.age = student.age - 1;
                    }
                    // Возраст на следующий день рождения
                    student.nextAge = student.age + 1;
                }

                return isUpcoming;
            });

            setUpcomingBirthdays(upcoming);

        } catch (error) {
            console.error('Fetch students error:', error);
        }
    };

    // API functions
    const getClasses = async () => {
        try {
            const resp = await mainGet({
                type: 'getClassesForWeek',
                s: `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`,
                id: localStorage.getItem('clid')
            });
            if (resp.data.ok) setCalendar(resp.data.data);
        } catch (error) {
            console.error('Error fetching classes:', error);
        }
    };

    const getSclasses = async () => {
        try {
            const resp = await mainGet({ type: 'getStudentClasses', st: user.name + ' ' + user.sname });
            if (resp.data.ok) setStClasses(resp.data.data);
            setReq(true);
        } catch (error) {
            console.error('Error fetching student classes:', error);
        }
    };

    const deleteClass = async (id) => {
        if (!window.confirm('Вы уверены, что хотите удалить это занятие?')) return;

        try {
            const resp = await mainGet({ type: 'delClass', id: localStorage.getItem('clid'), classId: id });
            if (resp.data.ok) {
                getClasses(); // Refresh classes instead of page reload
            } else {
                alert("Ошибка: " + resp.data.type);
            }
        } catch (error) {
            console.error('Error deleting class:', error);
        }
    };

    const getCurrentMonthIncome = () => {
        if (user.role !== 'student' && analytics?.advanced?.incM !== null) {
            const currentMonth = (new Date().getMonth() + 1).toString().padStart(2, '0');
            console.log(analytics?.advanced?.incM[currentMonth] || 0)
            return analytics?.advanced?.incM[currentMonth] || 0;
        }
        return analytics?.tpi || analytics?.tpp || 0;
    };

    const getTotalClassesThisMonth = () => {
        if (user.role !== 'student' && analytics?.advanced?.cl !== null) {
            const currentMonth = (new Date().getMonth() + 1).toString().padStart(2, '0');
            return analytics?.advanced?.cl[currentMonth] || 0;
        }
        return analytics?.tpc || 0;
    };

    const getTotalStudentsThisMonth = () => {
        if (user.role !== 'student' && analytics?.advanced?.su !== null) {
            const currentMonth = (new Date().getMonth() + 1).toString().padStart(2, '0');
            return analytics?.advanced?.su[currentMonth] || 0;
        }
        return analytics?.tps || 0;
    };

    const getAnalytics = async () => {
        const d = new Date();
        d.setMonth(d.getMonth() - 5 + 1);
        const month = d.getMonth() + 1;
        const leastD = `${d.getFullYear()}-${month < 10 ? `0${month}` : month}-01`;

        try {
            const rs = await mainPost({
                type: 'getAnalytics',
                currentMonth: date.getMonth() + 1,
                id: localStorage.getItem('clid'),
                coachN: user.name + " " + user.sname,
                role: user.role,
                leastD
            });
            if (rs.data.ok) setAnalytics(rs.data);
        } catch (error) {
            console.error('Error fetching analytics:', error);
        }
    };

    const getall_ = async () => {
        const clid = localStorage.getItem('clid');
        const key = localStorage.getItem('key');
        if (!clid || !key) {
            window.location.href = '/auth';
            return;
        }

        try {
            const re = await mainGet({ type: 'checkuser', id: clid, pass: key });
            if (re.data.ok) setUser(re.data.data);
        } catch (error) {
            console.error('Error fetching user data:', error);
        }
    };

    // Effects
    useEffect(() => {
        getall_();
        getClasses();
    }, []);

    useEffect(() => {
        if (user.name && user.role !== 'student' && !analytics) {
            getAnalytics();
        }
        if (user.name && user.role !== 'student') {
            fetchStudents();
        }
        if (user.name && user.role === 'student' && !req) {
            getSclasses();
        }
        if (user.name) {
            setLoading(false);
        }
    }, [user]);

    if (loading) {
        return (
            <div className="app-loading">
                <div className="loading-spinner">Загрузка...</div>
            </div>
        );
    }

    const roleTitles = {
        'admin': 'Администратор',
        'Sysadmin': 'Системный администратор',
        'student': 'Ученица',
        'coach': 'Тренер'
    };

    const todayClasses = calendar?.filter(d => d.date === `${date.getFullYear()}-${thisMonth}-${date.getDate()}`) || [];

    const ClassCard = ({ classData }) => {
        const isCompleted = classData.state === '1' &&
            (date.getHours() + '.' + date.getMinutes()) > clearAddTimes(addTimes([classData.time, classData.duration])) &&
            (new Date(todayDate).getTime() >= new Date(classData.date).getTime());

        const isCancelled = classData.state !== '1';

        return (
            <div className="class-card">
                <div className="class-status">
                    {isCancelled ? (
                        <span className="status-cancelled">Занятие отменено</span>
                    ) : isCompleted ? (
                        <span className="status-completed">Занятие завершено</span>
                    ) : (
                        <span className="status-upcoming">Предстоящее занятие</span>
                    )}
                </div>

                <div className="class-info">
                    <div className="info-item">
                        <label>{user.role === 'student' ? 'Тренер' : 'Ученица'}</label>
                        <span className="info-value">{user.role === 'student' ? classData.coach : classData.student}</span>
                    </div>

                    <div className="info-item">
                        <label>Время</label>
                        <span className="info-value">{classData.time} - {addTimes([classData.time, classData.duration])}</span>
                    </div>
                    {
                        user.role !== 'student' && (
                            <div className="info-item">
                                <label>Цена</label>
                                <span className="info-value price">{classData.price} ₽</span>
                            </div>
                        )
                    }
                </div>

                <div className="class-actions">
                    {user.role !== 'student' ? (
                        <button
                            className="btn btn-danger"
                            onClick={() => deleteClass(classData.id)}
                        >
                            Удалить
                        </button>
                    ) : classData.state === '1' ? (
                        <button
                            className="btn btn-warning"
                            onClick={() => alert('Функция отмены занятия находится в разработке')}
                        >
                            Отменить
                        </button>
                    ) : null}
                </div>
            </div>
        );
    };

    return (
        <div className="app">
            <Navbar usertype={user.role} fixedT={user?.fixed_trainer} />
            <Helmet>
                <title>Главная страница</title>
                <link rel="shortcut icon" href={logo} />
            </Helmet>

            <div className="main-content">
                <header className="page-header">
                    <h1 className="page-title">Вы вошли как {roleTitles[user.role]}</h1>
                    <h2 className="user-greeting">
                        Здравствуйте{user.role === 'student' ? '' : ','} {user.name} {user.role !== 'student' ? user.ots : ''}!
                    </h2>
                </header>

                {/* Analytics Section */}
                <section className="analytics-section">
                    <h2>{user.role !== 'student' ? "Аналитика за месяц" : "Краткая аналитика"}</h2>
                    <div className="analytics-grid">
                        {user.role !== 'student' ? (
                            <>
                                <div className="analytics-item">
                                    <span className="analytics-value">{getCurrentMonthIncome() || 0} ₽</span>
                                    <span className="analytics-label">Доход</span>
                                </div>
                                <div className="analytics-item">
                                    <span className="analytics-value">{getTotalClassesThisMonth() || 0}</span>
                                    <span className="analytics-label">Занятия</span>
                                </div>
                                <div className="analytics-item">
                                    <span className="analytics-value">{getTotalStudentsThisMonth() || 0}</span>
                                    <span className="analytics-label">Новые ученицы</span>
                                </div>
                            </>
                        ) : (
                            <>
                                <div className="analytics-item">
                                    <span className="analytics-value">{stClasses || 0}</span>
                                    <span className="analytics-label">Занятия</span>
                                </div>
                                <a href='/student-analytics' className="analytics-link">Смотреть всю аналитику</a>
                            </>
                        )}
                    </div>
                </section>
                {upcomingBirthdays.length > 0 && (
                    <section className="birthdays-section">
                        <h2>Ближайшие дни рождения</h2>
                        <div className="birthdays-list">
                            {upcomingBirthdays.map((student, index) => (
                                <div key={index} className="birthday-item">
    <span className="student-name">
        {student.name} {student.sname}
    </span>
                                    <span className="birthday-info">
        <span className="birthday-date">{student.bday}</span>
        <span className="birthday-age">Исполняется {student.nextAge} лет</span>
    </span>
                                </div>
                            ))}
                        </div>
                    </section>
                )}
                {/* Schedule Section */}
                <section className="schedule-section">
                    <div className="schedule-header">
                        <h2>Расписание на сегодня</h2>
                        <a href='/diary/calendar' className="calendar-link">
                            Смотреть календарь занятий →
                        </a>
                    </div>

                    <div className="date-display">
                        <div className="current-date">
                            <h3>{getDayOfWeek(Date.now())}</h3>
                            <h3>{formatDate(todayDate)}</h3>
                        </div>
                    </div>

                    <div className="classes-list">
                        {todayClasses.length > 0 ? (
                            todayClasses.map((classItem, index) => (
                                <ClassCard key={classItem.id || index} classData={classItem} />
                            ))
                        ) : (
                            <div className="no-classes">
                                <p>На сегодня занятий нет</p>
                            </div>
                        )}
                    </div>
                </section>
            </div>
        </div>
    );
}